<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import Tweezer from 'tweezer.js'
import nascarData from "@/js/nascarData";
import GaugeTelemetry from "./GaugeTelemetry.vue";
import mapUtility from "@/js/mapUtility";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { easeOutQuad } from 'ez.js'

const store = useStore();

const driverList = ref([]);
const searchState = ref(0);
const infoDisplayIndex = ref(0);
const infoDisplayData = ref([0]);
const infoDisplayTransition = ref("right-to-left");

const renderedResults = computed(() => {
    if(isMounted.value)
        return store.getters.results
    else
        return []
});

const options = ref({
          currentPage: 0
        });

const isMounted = ref(false);
onMounted(() => {
    driverList.value = store.getters.staticResultsLookup;
    isMounted.value = true;

    if(!store.getters.hasCommitFirstFavoriteDriver && store.getters.results.length > 0){
        store.commit('hasCommitFirstFavoriteDriver', true);
        onSelectDriver(0);
    }

    window.addEventListener("down-scroll", back);
})

onUnmounted(() => {
    isMounted.value = false;
    window.removeEventListener("down-scroll", back);
})


function back() {
    if (!isMounted.value) return;
    if (store.getters.favoriteDriver.data != null) {
        let { vehicleNo } = nascarData.getVehicleNoFromData(store.getters.favoriteDriver.data);
        console.log("unsubscribing from vehicle: " + vehicleNo)
        const lastChannel = nascarData.realtimeClient.channels.get(`vehicle${vehicleNo}`);
        lastChannel.unsubscribe(store.getters.favoriteDriver.boundListener);

        store.commit('favoriteDriverData', null)
    }
}

function onSelectDriver(index) {
    searchState.value = 1;

    store.commit('favoriteDriverTelemetry', null);

    if(store.getters.favoriteDriver.data != null){
        let {vehicleNo} = nascarData.getVehicleNoFromData(store.getters.favoriteDriver.data);
        console.log("unsubscribing from vehicle: " + vehicleNo)
        const lastChannel = nascarData.realtimeClient.channels.get(`vehicle${vehicleNo}`);
        lastChannel.unsubscribe(store.getters.favoriteDriver.boundListener);
    }

    //currentDriver.value = store.getters.results[index];
    let driverData = store.getters.results[index];
    store.commit('favoriteDriverData', driverData)
    console.log(store.getters.favoriteDriver.data)

    let {vehicleNo, driverID} = nascarData.getVehicleNoFromData(driverData);
    store.commit('favoriteDriverID', driverID)
    
    const boundFunction = nascarData.telemetryListenerSingleDriver.bind(nascarData, 'favoriteDriverTelemetry');
    const channel = nascarData.realtimeClient.channels.get(`vehicle${vehicleNo}`);
    channel.subscribe(boundFunction);
    store.commit('favoriteDriverBoundListener', boundFunction)
}

function onBeforeEnter(el) {
    if (el.dataset.index < 6) {
        el.style.opacity = 0;
        el.style.transform = `translateX(-20px)`
    } else {
        el.style.opacity = 1;
        el.style.transform = `translateX(0px)`
    }
}

async function onEnter(el, done) {
    if (el.dataset.index < 6) {
        await new Promise(resolve => setTimeout(resolve, el.dataset.index * 200))
        new Tweezer({
            start: 0,
            end: 1,
            duration: 600,
            easing: easeOutQuad
        })
            .on('tick', value => {
                el.style.opacity = value
                el.style.transform = `translateX(${(1 - value) * -20}px)`
            })
            .on('done', done)
            .begin() // this fires the tweening
    } else {
        done();
    }
}

const onSwiper = (swiper) => {
    console.log(swiper);
};
const onSlideChange = () => {
    console.log('slide change');
};

</script>

<template>
  <div class = "favorite-driver" :class = "{'show-overflow': store.getters.favoriteDriver.telemetry != null}">
    <transition name = "fade" mode = "out-in">
        <div class = "driver-lookup" v-if = "store.getters.favoriteDriver.data == null" key = "driver-lookup">
            <div class = "header flex-center">
                <div class = "header-text flex-center">
                    Select a Driver
                </div>
            </div>

            <div class = "modal-content flex-descending-column" >
                <TransitionGroup 
                    tag = "ul"
                    :css="false"
                        @before-enter="onBeforeEnter"
                        @enter="onEnter"
                >
                <div class = "loading-area" v-if = "renderedResults.length == 0">
                    <LoadingSpinner></LoadingSpinner>
                </div>
                <li v-for = "(standingItem, index) in renderedResults" :data-index="index"  :key = "standingItem.ps">
                    <button class = "list-item focusable" @click = "onSelectDriver(index)">
                        <div class = "left-section">
                            <div class = "car-logo-circle flex-center">
                                <img class = "car-logo" :src = "`https://cf.nascar.com/data/images/carbadges/1/${standingItem.no}.png`" alt = "">
                            </div>
                            <div class = "driver-name" v-if = "standingItem.drv != null">{{standingItem.drv.l_nm}}</div>
                            <div class = "driver-name" v-else-if = "standingItem.riData != null && store.getters.allDrivers[standingItem.riData.NASCARDriverID] != null">
                                {{store.getters.allDrivers[standingItem.riData.NASCARDriverID].Full_Name}}
                            </div>
                        </div>
                    </button>
                    </li>
                </TransitionGroup>
                
            </div>

        </div>
        <div class = "driver-view"  v-else-if = "store.getters.favoriteDriver.data != null" key = "driver-view">
            <div class = "header flex-center">
                <div class = "header-text flex-center">
                    <div class = "driver-photo">
                        <img :src = "store.getters.allDrivers[store.getters.favoriteDriver.id]?.Image" alt = "">
                    </div>
                    <img class="car-logo" :src="`https://cf.nascar.com/data/images/carbadges/1/${nascarData.getVehicleNoFromData(store.getters.favoriteDriver.data).vehicleNo}.png`" alt="">
  
                    <div v-if = "store.getters.allDrivers[store.getters.favoriteDriver.id] != null">
                        {{store.getters.allDrivers[store.getters.favoriteDriver.id].Full_Name}}
                    </div>
                </div>
            </div>
            <GaugeTelemetry key="gauge-cluster-fav"
                :show-loader="store.getters.favoriteDriver.telemetry == null"
                :spd="store.getters.favoriteDriver.telemetry?.mph"
                :rpm="store.getters.favoriteDriver.telemetry?.['Engine Speed']"
                :brake="store.getters.favoriteDriver.telemetry?.['Brake Pressure']"
                :throttle="store.getters.favoriteDriver.telemetry?.['Throttle Position']"
                :steering-angle='store.getters.favoriteDriver.telemetry?.["aSteering"]?.toFixed(2)'
                :gear='store.getters.favoriteDriver.telemetry?.["nGear"]'/>

  
        </div>
    </transition>
    
    </div>
</template>

<style lang="scss" scoped>

@import '../sass/GlobalClasses';
@import '../sass/Settings';
@import '../sass/Transitions';

.favorite-driver{
    padding: vw(20);
    position: fixed;
    left: vw(0);
    top: vw(0);
    right: vw(0);
    bottom: vw(0);
    overflow: hidden;
}

.loading-area{
    margin-top: vw(130);
}

.back-button{
    position: fixed;
    left: vw(20);
    top: vw(20);
    width: vw(70);
    height: vw(50);

    border: 2px white solid;
    border-radius: vw(25);
}

.loading-offset{
    margin-top: vw(190);
}

.show-overflow{
    overflow: visible;
}

.unit-text{
    font-size: vw(20);
    font-weight: 400;
}

.pagination-area{
    position: relative;
    width: 100%;
    height: auto;
    margin-top: vw(40);

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .pagination{
        position: relative;
        width: vw(8);
        height: vw(8);
        border-radius: vw(4);
        background-color: #DFDFDF;
        margin: 0 vw(3);
    }

    .active-pagination{
        width: vw(12);
        height: vw(12);
        border-radius: vw(6);
        background-color: #FFFFFF;
    }
}

.driver-view{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: visible;

    left: vw(0);
    top: vw(0);
    right: vw(0);
    bottom: vw(0);
    .header{
        position: relative;
        height: auto;
        margin-bottom: vw(10);
        margin-top: vw(-20);
        .header-text{
            position: relative;
            width: fit-content;
            padding: 0 vw(25) 0 0;
            height: vw(76);
            border-radius: vw(5);
            background-color: #4A4A4A;
            overflow: hidden;

            font-size: vw(24);
            font-weight: 400;
            text-wrap: none;

            *{
                font-size: vw(24);
                font-weight: 400;
            }

            .driver-photo{
                position: relative;
                width: vw(90);
                height: 100%;
                background-color: #CDCDCD;
                overflow: hidden;

                img{
                    position: absolute;
                    width: 90%;
                    height: auto;
                    bottom: -55%;
                    left: 5%;
                }

                margin-right: vw(10);
            }

            .car-logo{
                position: relative;
                width: vw(62);
                height: auto;
                margin-right: vw(10);
            }
        }
    }

    .stat-display-single{
        position: relative;
        width: vw(444);
        height: vw(219);
        border-radius: vw(40);
        background-color: #1C1C1E;
        margin-top: vw(20);
        padding: vw(30);

        border: 1px white solid;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .value{
            position: relative;
            font-size: vw(60);
        }

        .title{
            position: relative;
            font-size: vw(24);
            margin-top: vw(40);
            font-weight: 400;
        }
    }

    .stat-display{
        position: relative;
        width: vw(444);
        height: vw(357);
        border-radius: vw(40);
        background-color: #1C1C1E;
        margin-top: vw(20);
        padding: vw(30);

        border: 1px white solid;

        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;

        .stat-item{
            position: relative;
            width: 33%;
            height: 33%;

            .value{
                position: relative;
                font-size: vw(40);
            }

            .title{
                position: relative;
                font-size: vw(18);
                margin-top: vw(10);
                font-weight: 400;
            }
        }
    }

    .info-slide{
        position: relative;
        width: vw(420);
        height: vw(64);
        padding: vw(20);
        border-radius: vw(32);
        background-color: #4A4A4A;

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-size: vw(24);
    }
}


.driver-lookup{
    position: absolute;
    left: vw(40);
    top: vw(40);
    right: vw(40);
    bottom: vw(40);
    overflow: hidden;
    .header{
        position: relative;
        height: auto;
        .header-text{
            position: relative;
            width: fit-content;
            padding: 0 vw(20);
            height: vw(44);
            border-radius: vw(5);
            background-color: #007AC2;
            font-size: vw(24);
            font-weight: 400;
        }
    }

    .modal-content{
        margin-top: vw(15);
    }

    .list-item{
        position: relative;
        width: vw(420);
        min-height: vw(80);
        height: vw(80);
        font-size: vw(23);
        color: white;
        background: #626262;
        border-radius: vw(5);
        margin-bottom: vw(10);
        border: none;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: vw(30);

        

        .left-section{
            position: relative;
            height: 100%;
            width: contain;

            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            font-family: 'GoogleSansFlex';
            font-weight: 600;
            font-size: vw(24);

            .car-logo-circle{
                position: relative;
                width: vw(63);
                height: vw(57);
                overflow: hidden;

                .car-logo{
                    position: relative;
                    width: vw(63);
                    height: auto;
                }
            }   

            .driver-name{
                position: relative;
                margin-left: vw(15);
            }
        }
    }

    .list-item:focus{
        &:before{
            border-radius: vw(5);
            inset: vw(-1);
            border: solid vw(2) #0000;
        }
    }
}

</style>
